import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import { FormikErrors, FormikValues } from "formik";
import { connect } from "react-redux";
import { AppState } from "../../../store";
import { StepCounter } from "../styles/diversity-form-styles";
import Description from "./Description";
import Gender from "./Gender";
import Pronouns from "./Pronouns";
import Age from "./Age";
import Ethnicity from "./Ethnicity/Ethnicity";
import Disability from "./Disability";
import Orientation from "./Orientation";
import Religion from "./Religion";
import CaringResponsibilities from "./CaringResponsibilities/CaringResponsibilities";
import ThankYou from "./ThankYou";

interface IFormStepProps {
  step: number;
  values: {
    gender?: undefined | string;
    pronouns?: undefined | string;
    age?: null | string;
    ethnicGroup?: null | string;
    ethnicSubgroup?: null | string;
    disability?: null | string;
    orientation?: null | string;
    religion?: null | string;
    caringResponsibilities?: null | string;
    caringResponsibilitiesType?: null | string;
  };
  errors: FormikErrors<FormikValues>;
  setFieldValue: (
    field: string,
    value: unknown,
    shouldValidate: boolean
  ) => void;
}

export const FormStep: FunctionComponent<IFormStepProps> = (props) => {
  const { step, values, setFieldValue, errors } = props;
  let currentStep: JSX.Element;

  switch (step) {
    case 2:
      currentStep = (
        <Gender values={values} setFieldValue={setFieldValue} errors={errors} />
      );
      break;
    case 3:
      currentStep = (
        <Pronouns
          values={values}
          setFieldValue={setFieldValue}
          errors={errors}
        />
      );
      break;
    case 4:
      currentStep = <Age values={values} />;
      break;
    case 5:
      currentStep = (
        <Ethnicity
          values={values}
          setFieldValue={setFieldValue}
          errors={errors}
        />
      );
      break;
    case 6:
      currentStep = <Disability values={values} />;
      break;
    case 7:
      currentStep = (
        <Orientation
          values={values}
          setFieldValue={setFieldValue}
          errors={errors}
        />
      );
      break;
    case 8:
      currentStep = (
        <Religion
          values={values}
          setFieldValue={setFieldValue}
          errors={errors}
        />
      );
      break;
    case 9:
      currentStep = (
        <CaringResponsibilities
          values={values}
          setFieldValue={setFieldValue}
          errors={errors}
        />
      );
      break;
    case 10:
      currentStep = <ThankYou />;
      break;
    default:
      currentStep = <Description />;
      break;
  }
  return (
    <>
      {step > 1 && step < 10 && <StepCounter>Step {step - 1} of 8</StepCounter>}
      {currentStep}
    </>
  );
};

FormStep.propTypes = {
  values: PropTypes.shape({
    gender: PropTypes.string,
    pronouns: PropTypes.string,
    age: PropTypes.string,
    ethnicGroup: PropTypes.string,
    ethnicSubgroup: PropTypes.string,
    disability: PropTypes.string,
    orientation: PropTypes.string,
    religion: PropTypes.string,
    caringResponsibilities: PropTypes.string,
    caringResponsibilitiesType: PropTypes.string,
  }).isRequired,
  errors: PropTypes.shape({
    gender: PropTypes.string,
  }).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  step: PropTypes.number.isRequired,
};

const mapStateToProps = (state: AppState) => ({
  step: state.diversityForm.step,
});

export default connect(mapStateToProps, {})(FormStep);
